import type { EmployeeAlertInactiveManager, ListEmployeeAlertsQuery } from '@/common/graphql';

export const emptyEmployeeAlertList: ListEmployeeAlertsQuery['listEmployeeAlertsByEmployee'] = {
  totalCount: 0,
  countByPriority: {
    high: 0,
    medium: 0,
    low: 0,
  } as EmployeeAlertListItemCountByPriority,
  items: [],
};

export type EmployeeAlertListItem = ListEmployeeAlertsQuery['listEmployeeAlertsByEmployee']['items'][number];
export type EmployeeAlertListItemCountByPriority =
  ListEmployeeAlertsQuery['listEmployeeAlertsByEmployee']['countByPriority'];
export type EmployeeAlertListItemReason = EmployeeAlertListItem['reasons'][number];
export type EmployeeAlertListItemReasonManager =
  | EmployeeAlertInactiveManager['primaryManager']
  | EmployeeAlertInactiveManager['dottedLineManager'];
